import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggle(event) {
    const btn = event.currentTarget;
    const groupId = btn.dataset.groupId;
    const isOpen = btn.dataset.open === "true";

    if (isOpen) {
      this._hideGroup(groupId);
    } else {
      this._showGroup(groupId);
    }

    btn.dataset.open = isOpen ? "false" : "true";
    this._updateBtn(btn, !isOpen);
  }

  // Show only direct children of this group
  _showGroup(groupId) {
    this.element
      .querySelectorAll(`[data-parent-group="${groupId}"]`)
      .forEach((row) => {
        row.hidden = false;
      });
  }

  // Hide all children and recursively collapse any open sub-groups
  _hideGroup(groupId) {
    this.element
      .querySelectorAll(`[data-parent-group="${groupId}"]`)
      .forEach((row) => {
        row.hidden = true;

        // Find any nested toggle buttons inside this row and reset them
        row.querySelectorAll("[data-group-id]").forEach((subBtn) => {
          if (subBtn.dataset.open === "true") {
            this._hideGroup(subBtn.dataset.groupId);
            subBtn.dataset.open = "false";
            this._updateBtn(subBtn, false);
          }
        });
      });
  }

  _updateBtn(btn, open) {
    const label = btn.querySelector(".cs-toggle-label");
    const arrow = btn.querySelector(".cs-toggle-arrow");
    if (label) label.textContent = open ? "Hide child attributes" : "Show child attributes";
    if (arrow) arrow.classList.toggle("cs-toggle-arrow--open", open);
  }
}
